import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../configs/constants';

axios.defaults.withCredentials = true;

export const sendJsonData = async (data, path, isEdit = false) => {
    const method = isEdit ? 'PATCH' : 'POST';

    const formattedPath = path.charAt(0) === '/' ? path : `/${path}`;
    const url = process.env.REACT_APP_CMS_API_PATH + formattedPath;
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;

    console.log('url end bna', url);

    return await axios({
        url,
        method,
        data,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
